import { Model } from 'pinia-orm'

import { Attr, BelongsTo, Bool, HasMany, Num, Uid } from 'pinia-orm/dist/decorators'
import { Transaction } from 'modules/Transaction/Transaction'
import { TankLevelCalibration } from 'modules/TankLevelCalibration/TankLevelCalibration'
import { QrCode } from 'modules/QrCode/QrCode'
import { Fluid } from 'modules/Fluid/Fluid'
import { Device } from 'modules/Device/Device'
import { Tenant } from 'modules/Tenant/Tenant'
import { Org } from 'modules/Org/Org'

export class Tank extends Model {
  static override entity = 'tanks'

  // Fields
  @Uid() declare id: string
  @Num(null) declare int_id: number | null

  @Attr() declare name: null | string
  @Attr() declare tank_number: null | number
  @Attr() declare device_id: null | string
  @Attr() declare location: null | string
  @Attr() declare capacity: null | number
  @Attr() declare fluid_uom: null | string
  @Attr() declare make: null | string
  @Bool(true) declare is_active: null | boolean
  @Bool(false) declare is_portable: boolean
  @Attr() declare org_tank_name: null | string
  @Attr() declare fluid_id: null | string
  @Attr() declare serial: null | string
  @Bool(true) declare is_device_enabled: null | boolean
  @Bool(true) declare qr_scan_active: null | boolean
  @Attr() declare qr_code: null | string
  @Attr() declare date_qr_code_added: null | string
  @Attr() declare level_warning: null | number
  @Attr() declare level_reorder: null | number
  @Attr() declare latest_transaction_event_datetime: null | string

  @Attr() declare created_at: null | string
  @Attr() declare updated_at: null | string

  @BelongsTo(() => Device, 'device_id') declare device: Device | null
  @BelongsTo(() => Fluid, 'fluid_id') declare fluid: Fluid | null

  @HasMany(() => QrCode, 'qr_code_id') declare qrCodes: QrCode[]
  @HasMany(() => Transaction, 'transaction_id') declare transactions: Transaction[]
  @HasMany(() => TankLevelCalibration, 'tank_id') declare tank_level_calibrations: TankLevelCalibration[]

  @Attr(null) declare tenant_id: string
  @Attr(null) declare org_id: number
  @BelongsTo(() => Tenant, 'tenant_id') declare tenant: Tenant | null
  @BelongsTo(() => Org, 'org_id') declare org: Org | null
}
